import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60b01b2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","height":"24px","margin-bottom":"13px"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dc-card-header-defaut-line" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"16px","font-weight":"500"} }, "签到地址", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#999","font-size":"12px"} }, "（添加后才能签到打卡）", -1))
const _hoisted_6 = { style: {"flex":"1 1 0%","text-align":"right"} }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "总潜力业务量（票数/月）", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总TPR（票数/月）", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "总潜力物流费用（元/月）", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总TPR（元/月）", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "总潜力重量（KG/月）", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总TPR（KG/月）", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "不含上个月，即前第2到第4个月", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "主账号前三个月平均发货票数", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "不含上个月，即前第2到第4个月", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当前账号前三个月平均发货票数", -1))
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "潜力业务量（票数/月）", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "发货潜力（元/月）", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "发货潜力（KG/月）", -1))
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = { style: {"display":"flex","align-items":"center","height":"24px","margin-bottom":"13px"} }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dc-card-header-defaut-line" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"16px","font-weight":"500"} }, "物流商", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#999","font-size":"12px"} }, "（务必填写云途份额）", -1))
const _hoisted_27 = {
  key: 0,
  style: {"flex":"1 1 0%","text-align":"right"}
}
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = { class: "flex" }
const _hoisted_30 = { class: "flex" }

import { ref, reactive, computed, onBeforeMount, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { layoutTags } from '@dc-platform/dc-interaction'
import { DcConfirm, message } from '@dc-platform/dc-components'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { cloneDeep } from 'lodash-es'
import { contactValidate, concatNameValidate, selectForNumberValidate } from '@/utils/validate'
import UploadFile from '@/components/UploadFile'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { businessTypeEnum, customerTypeEnum, linkRoleTypeEnum, genderEnum, flagEnum } from '@/views/yuntuSales/commonEnum/dataConfig'
import { clueStatusEnum } from '@/views/yuntuSales/clueManage/dataConfig'
import { listByParamCodes, fetchUsersByWorkCode } from '@/api/common'
import { salesClueCreate, salesClueEdit } from '@/api/yuntuSales/clueManage'
import calc from '@/utils/calc'
import { initObjectVal, clearInvalid, paramCodesDataFilter } from '@/utils/index'
import type { FormInstance } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import type { ParamCodeItem } from '@/typings/common'
import type { LbuSalesClueEditParams } from '@/typings/api/clueManage'
import MapModal from '@/components/MapModal/index.vue'
import {
  checkAddressValidate,
  checkAddressData,
  handleAddressAdd,
  handleAddressAddDel,
  clear
} from '@/hooks/addressArrValidate'
import CosInputTianyancha from '@/components/Antd/CosInputTianyancha/index.vue'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import CosInput from '@/components/Antd/CosInput/index.vue'
import { isChannelDisabled } from '@/hooks/useChannel'
import { countryChannelRelevance } from '@/api/yuntuSales/operationsManage'
import CustomerLabelCascader from '@/components/CustomerLabelCascader/index.vue'
import { ValidateOptions } from 'ant-design-vue/lib/form/interface'
import { ComponentInternalInstance } from 'vue/dist/vue'
import { error } from 'echarts/types/src/util/log'


const __default__ = { name: 'DetailForm' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: Object,
  isEdit: {
    type: Boolean,
    required: true
  },
  type: {
    type: String,
    required: true,
    validator(value: string) {
      return ['add', 'edit', 'view'].includes(value)
    }
  },
  resetValue: {
    type: [Object, Array]
  }
},
  setup(__props) {

const router = useRouter()
const route = useRoute()

const props = __props
const clearMainAddressFlag = (index: number) => {
  if (dataForm.visitAddress) {
    for (const [i, item] of dataForm.visitAddress.entries()) {
      if (index === i) {
        item.mainAddressFlag = item.mainAddressFlag === 1 ? 0 : 1
      } else {
        item.mainAddressFlag = 0
      }
    }
  }
}
const permissionPage = computed(() => {
  return props.type === 'add'
    ? { save: 'lbu_clue_add_btn' }
    : {
        edit: 'lbu_clue_edit_btn',
        save: 'lbu_clue_edit_btn'
      }
})

const totalTprWeight = computed(() => {
  const result = dataForm.business.demandInfo?.reduce((sum, item) => {
    return calc.Add(sum, item.tprWeight || 0)
  }, 0)
  const value = Number(result)
  if (isNaN(value)) {
    return ''
  }
  return value.toLocaleString('en-US')
})

const tprTotal = computed(() => {
  const result = dataForm.business.demandInfo?.reduce((sum, item) => {
    return calc.Add(sum, item.amount || 0)
  }, 0)
  const value = Number(result)
  if (isNaN(value)) {
    return ''
  }
  return value.toLocaleString('en-US')
})
const tprPotential = computed(() => {
  const result = dataForm.business.demandInfo?.reduce(
    (prev: number, item: any) => calc.Add(prev, item.potentialBusinessVolume || 0),
    0
  )
  const value = Number(result)
  if (isNaN(value)) {
    return ''
  }
  return value.toLocaleString('en-US')
})
const initForm = reactive<LbuSalesClueEditParams.RootObject>({
  contact: {},
  duplicateConfirmFlag: false,
  business: {
    saleInfo: [{}],
    demandInfo: [{}],
    erpInfo: [{}],
    goodsCategoryInfo: [{}],
    logisticsProviderInfo: [{}]
  },
  visitAddress: [{}]
})

// 线索状态枚举
const clueStatusEnumComputed = computed(() => {
  let list: any[] = []
  if (props.type === 'add') {
    list = clueStatusEnum.filter((item) => item.value === 3 || item.value === 6)
  } else if (props.type === 'edit') {
    list = clueStatusEnum.filter((item) => item.value === 3 || item.value === 5 || item.value === 6)
  } else {
    list = clueStatusEnum.filter((item) => item.value)
    list.unshift({
      label: '待领取',
      value: 0
    }) // 为了处理从线索公海池跳转过来的情况
  }
  return list
})
const paramCodeData: {
  [key: string]: ParamCodeItem[]
} = reactive({
  lbu_department_title: [], // 职务
  lbu_customer_business_area: [], // 客户业务地区
  lbu_important: [], // 业务收入等级（月潜在收入）
  lbu_sales_category: [], // 销售品类
  lbu_cargo_type: [], // 货物类型
  lbu_logistics_service_provider: [], // 现有合作物流服务商
  lbu_shipping_channel: [], // 出货渠道
  lbu_daily_traffic: [], // 客户日均包裹数量
  lbu_sale_platform: [], // 在售电商平台
  lbu_demand_country: [], // 目的地国家（需求国家）
  lbu_erp_info: [], // ERP系统
  lbu_invalid_reason: [], // 无效原因,
  lbu_source_channel: []
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: [
      'lbu_department_title',
      'lbu_customer_business_area',
      'lbu_important',
      'lbu_sales_category',
      'lbu_cargo_type',
      'lbu_logistics_service_provider',
      'lbu_shipping_channel',
      'lbu_daily_traffic',
      'lbu_sale_platform',
      'lbu_demand_country',
      'lbu_erp_info',
      'lbu_invalid_reason',
      'lbu_sign_in_address_label',
      'lbu_source_channel'
    ]
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    Object.assign(paramCodeData, res.data)

    if (props.isEdit) {
      channelDisabled.value = isChannelDisabled(paramCodeData.lbu_source_channel, dataForm.channel)
    }
  })
}
onBeforeMount(() => {
  getByParamCodes()
})
// 获取当前用户的信息
const getFollowerInfo = (workCode: string) => {
  const employeeList = [workCode]
  fetchUsersByWorkCode({ employeeList }).then((res) => {
    const [followerInfo] = res.data
    if (followerInfo && followerInfo.lbuCustomerRegion != null) {
      dataForm.customerRegion = followerInfo.lbuCustomerRegion
    } else {
      dataForm.customerRegion = undefined
      setTimeout(() => formRef.value?.clearValidate('customerRegion'))
    }
  })
}

const formRef = ref<FormInstance>()
const isFutureClue = ref(false)
const queryClueId = computed(() => route.query.clueId as string)
const dataForm = reactive<LbuSalesClueEditParams.RootObject>(cloneDeep(initForm))

const channelDisabled = ref(false)

const isPerfect = ref(false)
const formRules: Record<string, Rule[]> = {
  businessType: [{
    required: true,
    message: '请选择'
  }],
  select: [{
    required: true,
    message: '请选择'
  }],
  selectNumber: [{
    required: true,
    validator: selectForNumberValidate,
    message: '请选择'
  }],
  input: [{
    required: true,
    message: '请输入'
  }],
  customerName: [{
    required: true,
    message: '请输入客户名称'
  }],
  clueStatus: [{
    required: true,
    validator: selectForNumberValidate,
    message: '请选择线索状态'
  }],
  channel: [{
    required: true,
    message: '请选择线索来源'
  }],
  follower: [{
    required: true,
    message: '请选择客户负责人'
  }],
  customerType: [{
    required: true,
    validator: selectForNumberValidate,
    message: '请选择客户类型'
  }],
  customerRegion: [{
    required: true,
    message: '请选择客户区域'
  }],
  futureContactTime: [{
    required: true,
    message: '请选择未来联系时间'
  }],
  contactName: [{
    required: true,
    message: '请输入联系人姓名'
  }, { validator: concatNameValidate }],
  invalid: [{
    required: true,
    message: '请选择无效原因'
  }],
  remarkValue: [{
    required: true,
    message: '请输入备注'
  }]
}
watch(
  () => route.query.isPerfect,
  (val) => {
    if (val === 'required') {
      isPerfect.value = true
    }
  },
  { immediate: true }
)
watch(
  () => dataForm.clueStatus,
  (val) => {
    // 控制未来线索必填校验
    if (val === 6) {
      isFutureClue.value = true
    } else {
      isFutureClue.value = false
      dataForm.futureContactTime = undefined
    }
  },
  { immediate: true }
)
watch(
  () => props.value,
  (val) => {
    if (val) {
      const formVal = {
        ...val
      }
      initObjectVal(formVal, initForm)
      if (!formVal.business.monthIncome) {
        formVal.business.monthIncome = undefined
      }
      if (formVal.business.saleInfo.length) {
        formVal.business.saleInfo.forEach((item: any) => {
          if (!item) return
          if (item.salePlatformId != null) {
            item.salePlatformId = item.salePlatformId || undefined
          }
          if (item.percent === null) item.percent = undefined
        })
      }
      if (formVal.business.demandInfo.length) {
        formVal.business.demandInfo.forEach((item: any) => {
          if (!item) return
          if (item.countryId != null) {
            item.countryId = item.countryId || undefined
          }
          if (item.amount === null) item.amount = undefined
          if (item.potentialBusinessVolume === null) item.potentialBusinessVolume = undefined
          if (item.shippingChannel === null) item.shippingChannel = undefined
        })
      }
      if (formVal.business.erpInfo.length) {
        formVal.business.erpInfo.forEach((item: any) => {
          if (!item) return
          if (item.erpId != null) {
            item.erpId = item.erpId || undefined
          }
          item.erpAccount = item.erpAccount || undefined
        })
      }
      Object.assign(dataForm, clearInvalid(formVal))
    }
  },
  {
    immediate: true,
    deep: true
  }
)

const handleFollowerChange = (val: any) => {
  if (val && props.type === 'add') getFollowerInfo(val)
}

const checkValidate = (rule: any, value: number | string, arr: any, name: string, message: string) => {
  const index = rule.field.split('.').slice(-2)[0] * 1
  const list = arr || []
  let key = list[index][name]
  if (['countryId', 'erpId'].includes(name) && key === -9) key = undefined

  // 选择“ERP”时不需要校验“关联账号”
  if (name === 'erpId') {
    return Promise.resolve()
  }

  if (key != null && key !== '' && (!value || value === -9)) {
    return Promise.reject(new Error(message))
  } else {
    return Promise.resolve()
  }
}
const percentValidate = async (rule: any, value: number, item: any) => {
  if (isPerfect.value) {
    if ((value == null || value === 0)) {
      return Promise.reject(new Error('请输入在售平台占比'))
    }
  } else {
    if (value == null || value === 0) {
      return (item.salePlatformId && item.salePlatformId !== -9) ? Promise.reject(new Error('请输入在售平台占比')) : Promise.resolve()
    }
  }
  const result = dataForm.business.saleInfo?.reduce((prev: number, curr: any) => calc.Add(prev, curr.percent || 0), 0)
  if (value && result !== 100) {
    return Promise.reject(new Error('在售平台占比总和等于100%'))
  } else {
    return Promise.resolve()
  }
}
const onSalesSelect = async (item: any, index: any) => {
  if (item.salePlatformId === null || item.salePlatformId === -9) {
    formRef.value?.validate([['business', 'saleInfo', index, 'percent']])
  }
}
/// 用来校验多个列表的输入框加起来要等于100之后让validator提示消失
const onSalesInput = async () => {
  const salesList = dataForm.business.saleInfo
  const validList = salesList?.map((item: any, index: number) => {
    if (item.salePlatformId != null && item.percent != null) {
      return ['business', 'saleInfo', index, 'percent']
    }
    return []
  })
  formRef.value?.validate(validList)
}
const logisticsProviderInfoValidate = async (rule: Rule, value: number, item: any) => {
  if (isPerfect.value) {
    if ((value == null || value === 0)) {
      return Promise.reject(new Error('请输入物流商占比'))
    }
  } else {
    if (value == null || value === 0) {
      return (item.currentLogisticsProvider && item.currentLogisticsProvider !== -9) ? Promise.reject(new Error('请输入物流商占比')) : Promise.resolve()
    }
  }
  let result = 0
  if (dataForm.business && dataForm.business.logisticsProviderInfo) {
    result = dataForm.business?.logisticsProviderInfo.reduce(
      (prev: number, curr: any) => calc.Add(prev, curr.percent || 0),
      0
    )
  }
  if (value && result !== 100) {
    return Promise.reject(new Error('物流商占比总和等于100%'))
  } else {
    return Promise.resolve()
  }
}
const onLogisticsProviderSelect = async (item: any, index: any) => {
  if (item.currentLogisticsProvider === null || item.currentLogisticsProvider === -9) {
    formRef.value?.validate([['business', 'logisticsProviderInfo', index, 'percent']])
  }
}
const onLogisticsProviderInput = async () => {
  const logistics = dataForm.business.logisticsProviderInfo
  const validList = logistics?.map((item: any, index: number) => {
    if (item.currentLogisticsProvider != null && item.percent != null) {
      return ['business', 'logisticsProviderInfo', index, 'percent']
    }
    return []
  })
  formRef.value?.validate(validList)
}
const goodsCategoryInfoValidate = async (rule: Rule, value: number, item: any) => {
  if (isPerfect.value) {
    if ((value == null || value === 0)) {
      return Promise.reject(new Error('请输入品类占比'))
    }
  } else {
    if (value == null || value === 0) {
      return (item.goodsCategory && item.goodsCategory !== -9) ? Promise.reject(new Error('请输入品类占比')) : Promise.resolve()
    }
  }
  let result = 0
  if (dataForm.business && dataForm.business.goodsCategoryInfo) {
    result = dataForm.business?.goodsCategoryInfo.reduce(
      (prev: number, curr: any) => calc.Add(prev, curr.percent || 0),
      0
    )
  }
  if (value && result !== 100) {
    return Promise.reject(new Error('品类占比总和等于100%'))
  } else {
    return Promise.resolve()
  }
}
const onGoodsCategorySelect = async (item: any, index: any) => {
  if (item.goodsCategory === null || item.goodsCategory === -9) {
    formRef.value?.validate([['business', 'goodsCategoryInfo', index, 'percent']])
  }
}
const onGoodsCategoryInput = async () => {
  const goodsCategoryInfos = dataForm.business.goodsCategoryInfo
  const validList = goodsCategoryInfos?.map((item: any, index: number) => {
    if (item.goodsCategory != null && item.percent != null) {
      return ['business', 'goodsCategoryInfo', index, 'percent']
    }
    return []
  })
  formRef.value?.validate(validList)
}
const handleAddCol = (arr: {}[]) => {
  arr.push({})
}
// 删除列
const handleDelCol = (arr: {}[], index: number) => {
  arr.splice(index, 1)
}
const handleSalePlatformAdd = () => {
  dataForm.business.saleInfo?.push({
    salePlatformId: undefined,
    percent: undefined
  })
}
const handleSalePlatformDel = (index: number) => {
  dataForm.business.saleInfo?.splice(index, 1)
}
const handleDemandInfoAdd = () => {
  dataForm.business.demandInfo?.push({
    countryId: undefined,
    amount: undefined,
    potentialBusinessVolume: undefined,
    shippingChannel: undefined
  })
}
const handleDemandInfoDel = (index: number) => {
  dataForm.business.demandInfo?.splice(index, 1)
}
const handleErpInfoAdd = () => {
  dataForm.business.erpInfo?.push({
    erpId: undefined,
    erpAccount: undefined
  })
}
const handleErpInfoDel = (index: number) => {
  dataForm.business.erpInfo?.splice(index, 1)
}

const goBack = () => {
  if (location.hostname === 'localhost') {
    router.back()
  } else {
    layoutTags.close()
  }
}

const loading = ref(false)
const handleSubmit = async () => {
  try {
    loading.value = true
    const params: any = cloneDeep(dataForm)
    // 联系方式为空的字段需要删除，否则接口会报错
    // for (const key in params.contact) {
    //   if (params.contact[key] === '' || params.contact[key] == null) delete params.contact[key]
    // }
    // params.business.tpr = tprTotal
    // 地址为空清除、判断地址是否重复
    if (checkAddressData(dataForm.visitAddress)) {
      message.error('签到地址不可重复！')
      loading.value = false
      return false
    }
    const { visitAddress } = params
    params.visitAddress = clear(visitAddress, ['addressName', 'geoPoint'])
    // 新增、编辑的格式和详情不同、多传attrList
    if (JSON.stringify(params.visitAddress) === '[{}]') {
      params.visitAddress = { attrList: [] }
    } else {
      params.visitAddress = { attrList: params.visitAddress }
    }
    params.business.tpr = params.business.demandInfo?.reduce((sum: number, item: any) => {
      if (item.amount != null) {
        return calc.Add(sum, item.amount || 0)
      }
      return calc.Add(sum, 0)
    }, 0)
    params.business.totalPotential = params.business.demandInfo?.reduce((sum: number, item: any) => {
      if (item.potentialBusinessVolume != null) {
        return calc.Add(sum, item.potentialBusinessVolume || 0)
      }
      return calc.Add(sum, 0)
    }, 0)
    params.business.saleInfo = params.business.saleInfo?.filter((item: any) => {
      return item.salePlatformId != null && item.percent != null
    })
    params.business.demandInfo = params.business.demandInfo?.filter((item: any) => {
      const allNull = item.countryId === null && item.amount === null && item.potentialBusinessVolume === null && item.shippingChannel === null
      return !allNull
    })
    params.business.erpInfo = params.business.erpInfo?.filter((item: any) => {
      return item.erpId != null
    })
    params.business.goodsCategoryInfo = params.business.goodsCategoryInfo?.filter((item: any) => {
      return item.goodsCategory != null && item.percent != null
    })
    params.business.logisticsProviderInfo = params.business.logisticsProviderInfo?.filter((item: any) => {
      return item.currentLogisticsProvider != null && item.percent != null
    })
    if (queryClueId.value) {
      params.id = queryClueId.value
      const data = await salesClueEdit(params, { custom: { errorMsg: false } })
      if (data.code === 200) {
        message.success('修改线索成功')
        goBack()
      } else if (data.code === 12000002) {
        DcConfirm.warning({
          title: '操作提示！',
          content: `${data.message}，是否继续提交？`,
          cancelText: '取消',
          okText: '继续',
          onOk() {
            params.duplicateConfirmFlag = true
            salesClueEdit(params).then(() => {
              message.success('修改线索成功')
              goBack()
            })
          }
        })
      } else {
        message.error(data.message)
      }
    } else {
      const data = await salesClueCreate(params, { custom: { errorMsg: false } })
      if (data.code === 200) {
        message.success('新增线索成功')
        goBack()
      } else if (data.code === 12000002) {
        DcConfirm.warning({
          title: '操作提示！',
          content: `${data.message}，是否继续提交？`,
          cancelText: '取消',
          okText: '继续',
          onOk() {
            params.duplicateConfirmFlag = true
            salesClueCreate(params).then(() => {
              message.success('新增线索成功')
              goBack()
            })
          }
        })
      } else {
        message.error(data.message)
      }
    }
  } catch (errorInfo: any) {
    loading.value = false
    formRef.value?.scrollToField(errorInfo.errorFields[0].name.toString())
  }
  loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_CosRadioGroup = _resolveComponent("CosRadioGroup")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_CosInputNumber = _resolveComponent("CosInputNumber")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref_key: "formRef",
      ref: formRef,
      model: dataForm,
      rules: formRules,
      autocomplete: "off",
      scrollToFirstError: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_card, {
          title: "基础信息",
          span: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: "客户名称",
              name: "customerName"
            }, {
              default: _withCtx(() => [
                _createVNode(CosInputTianyancha, {
                  value: dataForm.customerName,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.customerName) = $event)),
                  maxlength: 100,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  appId: "cos_lbu"
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }),
            (props.type === 'view')
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  label: "ID"
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosInput, {
                      value: dataForm.clueId,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.clueId) = $event)),
                      view: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              label: "状态",
              name: "clueStatus"
            }, {
              label: _withCtx(() => [
                _createTextVNode(" 状态 "),
                _createVNode(_component_a_tooltip, {
                  placement: "topLeft",
                  overlayStyle: { maxWidth: '800px' }
                }, {
                  title: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clueStatusEnumComputed.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.value
                      }, [
                        (item.desc)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(item.label) + _toDisplayString(item.desc ? `：${item.desc}` : ''), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: dataForm.clueStatus,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.clueStatus) = $event)),
                  options: clueStatusEnumComputed.value,
                  disabled: !props.isEdit,
                  placeholder: "请选择",
                  allowClear: "",
                  view: props.type === 'view'
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "来源渠道",
              name: "channel",
              class: "form-item_compact"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_group, {
                  compact: "",
                  class: "cos-view-input-group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(ParamCodeCascader, {
                      value: dataForm.channel,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.channel) = $event)),
                      cosDes: dataForm.channelExplain,
                      appId: "cos_lbu",
                      paramCode: "lbu_source_channel",
                      status: props.type === 'view' ? undefined : 0,
                      disabled: !props.isEdit || channelDisabled.value,
                      view: props.type === 'view',
                      style: {"width":"33%"}
                    }, null, 8, ["value", "cosDes", "status", "disabled", "view"]),
                    _createVNode(_component_dc_form_item, {
                      name: "channelExplain",
                      span: 24,
                      style: {"width":"67%"},
                      class: "last-compact"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(CosInput, {
                          value: dataForm.channelExplain,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((dataForm.channelExplain) = $event)),
                          maxlength: 100,
                          disabled: !props.isEdit || channelDisabled.value,
                          view: props.type === 'view'
                        }, null, 8, ["value", "disabled", "view"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "客户负责人",
              name: "follower"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UserSelect, {
                  permission: "",
                  value: dataForm.follower,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((dataForm.follower) = $event)),
                  defaultValue: "me",
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  placeholder: "请选择",
                  allowClear: "",
                  onChange: handleFollowerChange
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "客户类型",
              name: "customerType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: dataForm.customerType,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((dataForm.customerType) = $event)),
                  options: _unref(customerTypeEnum),
                  disabled: !props.isEdit,
                  placeholder: "请选择",
                  allowClear: "",
                  view: props.type === 'view'
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "客户区域",
              name: "customerRegion"
            }, {
              default: _withCtx(() => [
                _createVNode(CustomerAreaCascader, {
                  appId: "cos_lbu",
                  value: dataForm.customerRegion,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((dataForm.customerRegion) = $event)),
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "客户合同地址",
              name: "customerAddress"
            }, {
              default: _withCtx(() => [
                _createVNode(CosInput, {
                  value: dataForm.customerAddress,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((dataForm.customerAddress) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: true,
                  placeholder: "请输入",
                  view: props.type === 'view'
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "客户标签" }, {
              default: _withCtx(() => [
                _createVNode(CustomerLabelCascader, {
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  type: "search",
                  appId: "cos_lbu",
                  ids: dataForm.labelIdList,
                  "onUpdate:ids": _cache[9] || (_cache[9] = ($event: any) => ((dataForm.labelIdList) = $event)),
                  value: dataForm.labelIdList,
                  allowClear: ""
                }, null, 8, ["disabled", "view", "ids", "value"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "业务类型",
              name: "businessType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: dataForm.businessType,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((dataForm.businessType) = $event)),
                  options: _unref(businessTypeEnum),
                  disabled: !props.isEdit,
                  placeholder: "请选择",
                  allowClear: "",
                  view: props.type === 'view'
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }),
            (isFutureClue.value)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 1,
                  name: "futureContactTime",
                  label: "未来联系时间",
                  rules: isFutureClue.value ? formRules.futureContactTime : []
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosSingleDateTimePicker, {
                      startTime: dataForm.futureContactTime,
                      "onUpdate:startTime": _cache[11] || (_cache[11] = ($event: any) => ((dataForm.futureContactTime) = $event)),
                      isRange: false,
                      view: props.type === 'view'
                    }, null, 8, ["startTime", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]))
              : _createCommentVNode("", true),
            (props.type === 'view')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_dc_form_item, { label: "客户识别码" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: dataForm.customerSerial,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((dataForm.customerSerial) = $event)),
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "未跟进天数" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: dataForm.notFollowDayNum,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((dataForm.notFollowDayNum) = $event)),
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "创建人" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: dataForm.createByName,
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((dataForm.createByName) = $event)),
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "创建时间" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: dataForm.createTime,
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((dataForm.createTime) = $event)),
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "首次领取时间" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: dataForm.firstReceiveTime,
                        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((dataForm.firstReceiveTime) = $event)),
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "最后一次领取时间" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: dataForm.lastReceiveTime,
                        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((dataForm.lastReceiveTime) = $event)),
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "转为潜在时间" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: dataForm.stageChangeTime,
                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((dataForm.stageChangeTime) = $event)),
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "更新时间" }, {
                    default: _withCtx(() => [
                      _createVNode(CosInput, {
                        value: dataForm.updateTime,
                        "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((dataForm.updateTime) = $event)),
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, {
          title: "联系人信息",
          span: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: "联系人姓名",
              name: ['contact', 'name'],
              rules: formRules.contactName
            }, {
              default: _withCtx(() => [
                _createVNode(CosInput, {
                  value: dataForm.contact.name,
                  "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((dataForm.contact.name) = $event)),
                  maxlength: 100,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "手机号",
              name: ['contact', 'mobile'],
              rules: {required: dataForm.businessType === 1, validator: (rule, value) => _unref(contactValidate)(rule, value, dataForm.contact, formRef.value, dataForm.businessType === 1)}
            }, {
              default: _withCtx(() => [
                _createVNode(CosInput, {
                  value: dataForm.contact.mobile,
                  "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((dataForm.contact.mobile) = $event)),
                  maxlength: 100,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "邮箱",
              name: ['contact', 'email'],
              rules: {validator: (rule, value) => _unref(contactValidate)(rule, value, dataForm.contact, formRef.value, dataForm.businessType === 1)}
            }, {
              default: _withCtx(() => [
                _createVNode(CosInput, {
                  value: dataForm.contact.email,
                  "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((dataForm.contact.email) = $event)),
                  maxlength: 100,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "微信号",
              name: ['contact', 'wechat'],
              rules: {required: dataForm.businessType === 1, validator: (rule, value) => _unref(contactValidate)(rule, value, dataForm.contact, formRef.value, dataForm.businessType === 1)}
            }, {
              default: _withCtx(() => [
                _createVNode(CosInput, {
                  value: dataForm.contact.wechat,
                  "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((dataForm.contact.wechat) = $event)),
                  maxlength: 100,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "QQ号",
              name: ['contact', 'qq'],
              rules: {validator: (rule, value) => _unref(contactValidate)(rule, value, dataForm.contact, formRef.value, dataForm.businessType === 1)}
            }, {
              default: _withCtx(() => [
                _createVNode(CosInput, {
                  value: dataForm.contact.qq,
                  "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((dataForm.contact.qq) = $event)),
                  maxlength: 100,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "固定电话",
              name: ['contact', 'tel'],
              rules: {validator: (rule, value) => _unref(contactValidate)(rule, value, dataForm.contact, formRef.value, dataForm.businessType === 1)}
            }, {
              default: _withCtx(() => [
                _createVNode(CosInput, {
                  value: dataForm.contact.tel,
                  "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((dataForm.contact.tel) = $event)),
                  maxlength: 100,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "传真号",
              name: ['contact', 'fax']
            }, {
              default: _withCtx(() => [
                _createVNode(CosInput, {
                  value: dataForm.contact.fax,
                  "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((dataForm.contact.fax) = $event)),
                  maxlength: 100,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "性别",
              name: ['contact', 'sex']
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosRadioGroup, {
                  value: dataForm.contact.sex,
                  "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((dataForm.contact.sex) = $event)),
                  options: _unref(genderEnum),
                  view: props.type === 'view'
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "角色",
              name: ['contact', 'jobRole'],
              rules: formRules.selectNumber
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: dataForm.contact.jobRole,
                  "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((dataForm.contact.jobRole) = $event)),
                  options: _unref(linkRoleTypeEnum),
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  placeholder: "请选择",
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "职务",
              name: ['contact', 'jobDuty'],
              rules: formRules.selectNumber
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.contact.jobDuty,
                  "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((dataForm.contact.jobDuty) = $event)),
                  options: paramCodeData.lbu_department_title,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "备注",
              span: 12,
              name: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(CosInput, {
                  value: dataForm.contact.remark,
                  "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((dataForm.contact.remark) = $event)),
                  maxlength: 2000,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, {
          title: "签到地址（添加后才能签到打卡）",
          span: 6
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                (props.isEdit)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      ghost: "",
                      onClick: _cache[31] || (_cache[31] = ($event: any) => (_unref(handleAddressAdd)(dataForm.visitAddress)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("新增 ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(MultipleItem, {
              view: props.type === 'view',
              line: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForm.visitAddress, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '签到地址',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['visitAddress', index, 'addressName'],
                      rules: [
            { validator: (rule, value) => _unref(checkAddressValidate)(rule, value, dataForm.visitAddress, 'addressTag', '请选择') }
          ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(MapModal, {
                          address: item.addressName,
                          "onUpdate:address": ($event: any) => ((item.addressName) = $event),
                          geoPoint: item.geoPoint,
                          "onUpdate:geoPoint": ($event: any) => ((item.geoPoint) = $event),
                          view: props.type === 'view'
                        }, null, 8, ["address", "onUpdate:address", "geoPoint", "onUpdate:geoPoint", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '补充地址',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['visitAddress', index, 'suppAddress']
                    }, {
                      default: _withCtx(() => [
                        _createVNode(CosInput, {
                          value: item.suppAddress,
                          "onUpdate:value": ($event: any) => ((item.suppAddress) = $event),
                          view: props.type === 'view'
                        }, null, 8, ["value", "onUpdate:value", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '地址类型',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['visitAddress', index, 'addressTag'],
                      rules: [
            { validator: (rule, value) => _unref(checkAddressValidate)(rule, value, dataForm.visitAddress, 'addressName', '请输入') }
          ]
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.lbu_sign_in_address_label,
                            value: item.addressTag,
                            "onUpdate:value": ($event: any) => ((item.addressTag) = $event),
                            disabled: !props.isEdit,
                            view: props.type === 'view',
                            allowClear: "",
                            style: {"width":"100%"}
                          }, null, 8, ["options", "value", "onUpdate:value", "disabled", "view"]),
                          (props.isEdit && dataForm.visitAddress && dataForm.visitAddress.length > 1)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                danger: "",
                                style: {"padding":"0 0 0 12px"},
                                onClick: ($event: any) => (_unref(handleAddressAddDel)(index, dataForm.visitAddress))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除 ")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_checkbox, {
                            style: {"padding":"3px 0 0 12px","width":"150px"},
                            disabled: props.type === 'view',
                            checked: item.mainAddressFlag === 1,
                            onChange: ($event: any) => (clearMainAddressFlag(index))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("主要 ")
                            ]),
                            _: 2
                          }, 1032, ["disabled", "checked", "onChange"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_a_col, { span: 6 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, {
          title: "业务信息",
          span: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, { label: "业务收入等级" }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  value: dataForm.business.monthIncome,
                  "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((dataForm.business.monthIncome) = $event)),
                  options: paramCodeData.lbu_important,
                  disabled: !props.isEdit,
                  view: props.type === 'view',
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "年销售GMV(元)" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInputNumber, {
                  value: dataForm.business.annualSales,
                  "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((dataForm.business.annualSales) = $event)),
                  "cos-type": "money",
                  min: 0,
                  maxlength: 15,
                  precision: 2,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "总TPR（票数/月）" }, {
              label: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  placement: "topLeft",
                  overlayStyle: { maxWidth: '800px' }
                }, {
                  title: _withCtx(() => [
                    _hoisted_8
                  ]),
                  default: _withCtx(() => [
                    _hoisted_9,
                    _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(CosInput, {
                  value: tprPotential.value,
                  "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((tprPotential).value = $event)),
                  placeholder: "自动计算",
                  maxlength: 100,
                  disabled: props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "总TPR（元/月）" }, {
              label: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  placement: "topLeft",
                  overlayStyle: { maxWidth: '800px' }
                }, {
                  title: _withCtx(() => [
                    _hoisted_10
                  ]),
                  default: _withCtx(() => [
                    _hoisted_11,
                    _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(CosInput, {
                  value: tprTotal.value,
                  placeholder: "自动计算",
                  maxlength: 100,
                  disabled: props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }),
            (dataForm.businessType === 1)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  label: "总TPR（KG/月）"
                }, {
                  label: _withCtx(() => [
                    _createVNode(_component_a_tooltip, {
                      placement: "topLeft",
                      overlayStyle: { maxWidth: '800px' }
                    }, {
                      title: _withCtx(() => [
                        _hoisted_12
                      ]),
                      default: _withCtx(() => [
                        _hoisted_13,
                        _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(CosInput, {
                      value: totalTprWeight.value,
                      placeholder: "自动计算",
                      maxlength: 100,
                      disabled: props.isEdit,
                      view: props.type === 'view'
                    }, null, 8, ["value", "disabled", "view"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (props.type === 'view')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_dc_form_item, { label: "主账号上月发货票数" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: dataForm.business.uitQty,
                        "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((dataForm.business.uitQty) = $event)),
                        "cos-type": "money",
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "主账号去年上月发货票数" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: dataForm.business.lyUitQty,
                        "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((dataForm.business.lyUitQty) = $event)),
                        "cos-type": "money",
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "主账号前三个月平均发货票数" }, {
                    label: _withCtx(() => [
                      _createVNode(_component_a_tooltip, {
                        placement: "topLeft",
                        overlayStyle: { maxWidth: '800px' }
                      }, {
                        title: _withCtx(() => [
                          _hoisted_14
                        ]),
                        default: _withCtx(() => [
                          _hoisted_15,
                          _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: dataForm.business.avgQty,
                        "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((dataForm.business.avgQty) = $event)),
                        "cos-type": "money",
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "当前账号上月发货票数" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: dataForm.business.ctUitQty,
                        "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((dataForm.business.ctUitQty) = $event)),
                        "cos-type": "money",
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "当前账号去年上月发货票数" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: dataForm.business.ctLyUitQty,
                        "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((dataForm.business.ctLyUitQty) = $event)),
                        "cos-type": "money",
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "当前账号前三个月平均发货票数" }, {
                    label: _withCtx(() => [
                      _createVNode(_component_a_tooltip, {
                        placement: "topLeft",
                        overlayStyle: { maxWidth: '800px' }
                      }, {
                        title: _withCtx(() => [
                          _hoisted_16
                        ]),
                        default: _withCtx(() => [
                          _hoisted_17,
                          _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: dataForm.business.ctAvgQty,
                        "onUpdate:value": _cache[40] || (_cache[40] = ($event: any) => ((dataForm.business.ctAvgQty) = $event)),
                        "cos-type": "money",
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "总OPR金额" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: dataForm.business.totalOprAmount,
                        "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((dataForm.business.totalOprAmount) = $event)),
                        "cos-type": "money",
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "总OPR票数" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: dataForm.business.totalOprMau,
                        "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((dataForm.business.totalOprMau) = $event)),
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "总OPR重量" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: dataForm.business.totalOprWeight,
                        "onUpdate:value": _cache[43] || (_cache[43] = ($event: any) => ((dataForm.business.totalOprWeight) = $event)),
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "总OPR方数" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInputNumber, {
                        value: dataForm.business.totalOprCube,
                        "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((dataForm.business.totalOprCube) = $event)),
                        min: 0,
                        maxlength: 15,
                        view: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, {
          title: "在售平台",
          span: 6,
          name: "platform"
        }, _createSlots({
          default: _withCtx(() => [
            _createVNode(MultipleItem, {
              view: props.type === 'view',
              line: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForm.business.saleInfo, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '在售电商平台',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['business', 'saleInfo', index, 'salePlatformId'],
                      rules: [{ required: isPerfect.value, validator: (rule, value) => checkValidate(rule, value, dataForm.business.saleInfo, 'percent', '请选择') }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          value: item.salePlatformId,
                          "onUpdate:value": ($event: any) => ((item.salePlatformId) = $event),
                          options: paramCodeData.lbu_sale_platform,
                          disabled: !props.isEdit,
                          view: props.type === 'view',
                          allowClear: "",
                          onChange: ($event: any) => (onSalesSelect(item,index))
                        }, null, 8, ["value", "onUpdate:value", "options", "disabled", "view", "onChange"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '在售平台占比(%)',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['business', 'saleInfo', index, 'percent'],
                      rules: [{ required: isPerfect.value, validator: (rule, inputValue) => percentValidate(rule, inputValue, item)}]
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_CosInputNumber, {
                            value: item.percent,
                            "onUpdate:value": ($event: any) => ((item.percent) = $event),
                            min: 0,
                            disabled: !props.isEdit,
                            view: props.type === 'view',
                            onChange: onSalesInput,
                            style: {"width":"100%"}
                          }, null, 8, ["value", "onUpdate:value", "disabled", "view"]),
                          (props.isEdit && dataForm.business.saleInfo && dataForm.business.saleInfo.length > 1)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                danger: "",
                                style: {"padding":"0 0 0 12px"},
                                onClick: ($event: any) => (handleSalePlatformDel(index))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除 ")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_a_col, { span: 12 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 2
        }, [
          (props.isEdit)
            ? {
                name: "subTitle",
                fn: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    ghost: "",
                    onClick: _cache[45] || (_cache[45] = ($event: any) => (handleSalePlatformAdd()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1024),
        _createVNode(_component_dc_layout_card, {
          title: "目的地国家",
          span: 4
        }, _createSlots({
          default: _withCtx(() => [
            _createVNode(MultipleItem, {
              view: props.type === 'view',
              line: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForm.business.demandInfo, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '目的地国家',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['business', 'demandInfo', index, 'countryId']
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          value: item.countryId,
                          "onUpdate:value": ($event: any) => ((item.countryId) = $event),
                          options: paramCodeData.lbu_demand_country,
                          disabled: !props.isEdit,
                          view: props.type === 'view',
                          allowClear: ""
                        }, null, 8, ["value", "onUpdate:value", "options", "disabled", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '出货渠道',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['business', 'demandInfo', index, 'shippingChannel']
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          value: item.shippingChannel,
                          "onUpdate:value": ($event: any) => ((item.shippingChannel) = $event),
                          options: paramCodeData.lbu_shipping_channel,
                          disabled: !__props.isEdit,
                          view: props.type === 'view',
                          mode: "multiple"
                        }, null, 8, ["value", "onUpdate:value", "options", "disabled", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : 'TPR（票数/月）',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['business', 'demandInfo', index, 'potentialBusinessVolume']
                    }, {
                      label: _withCtx(() => [
                        _createVNode(_component_a_tooltip, {
                          placement: "topLeft",
                          overlayStyle: { maxWidth: '800px' }
                        }, {
                          title: _withCtx(() => [
                            _hoisted_19
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(`${index ? '' : 'TPR（票数/月）'}`), 1),
                            _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_CosInputNumber, {
                          value: item.potentialBusinessVolume,
                          "onUpdate:value": ($event: any) => ((item.potentialBusinessVolume) = $event),
                          min: 0,
                          maxlength: 15,
                          "cos-type": "money",
                          disabled: !props.isEdit,
                          view: props.type === 'view',
                          style: {"width":"100%"}
                        }, null, 8, ["value", "onUpdate:value", "disabled", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : 'TPR（元/月）',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['business', 'demandInfo', index, 'amount']
                    }, {
                      label: _withCtx(() => [
                        _createVNode(_component_a_tooltip, {
                          placement: "topLeft",
                          overlayStyle: { maxWidth: '800px' }
                        }, {
                          title: _withCtx(() => [
                            _hoisted_20
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(`${index ? '' : 'TPR（元/月）'}`), 1),
                            _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_CosInputNumber, {
                          value: item.amount,
                          "onUpdate:value": ($event: any) => ((item.amount) = $event),
                          min: 0,
                          maxlength: 15,
                          "cos-type": "money",
                          disabled: !props.isEdit,
                          view: props.type === 'view',
                          style: {"width":"100%"}
                        }, null, 8, ["value", "onUpdate:value", "disabled", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : 'TPR（KG/月）',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['business', 'demandInfo', index, 'tprWeight']
                    }, {
                      label: _withCtx(() => [
                        _createVNode(_component_a_tooltip, {
                          placement: "topLeft",
                          overlayStyle: { maxWidth: '800px' }
                        }, {
                          title: _withCtx(() => [
                            _hoisted_21
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(`${index ? '' : 'TPR（KG/月）'}`), 1),
                            _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_CosInputNumber, {
                            value: item.tprWeight,
                            "onUpdate:value": ($event: any) => ((item.tprWeight) = $event),
                            min: 0,
                            maxlength: 15,
                            "cos-type": "money",
                            disabled: !props.isEdit,
                            view: props.type === 'view',
                            style: {"width":"100%"}
                          }, null, 8, ["value", "onUpdate:value", "disabled", "view"]),
                          (props.isEdit && dataForm.business.demandInfo && dataForm.business.demandInfo.length > 1)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                danger: "",
                                style: {"padding":"0 0 0 12px"},
                                onClick: ($event: any) => (handleDemandInfoDel(index))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除 ")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name"]),
                    _createVNode(_component_a_col, { span: 24 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 2
        }, [
          (props.isEdit)
            ? {
                name: "subTitle",
                fn: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    ghost: "",
                    onClick: _cache[46] || (_cache[46] = ($event: any) => (handleDemandInfoAdd()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1024),
        _createVNode(_component_dc_layout_card, {
          title: "物流商（务必填写云途份额）",
          span: 6
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _hoisted_25,
              _hoisted_26,
              (props.isEdit)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      ghost: "",
                      onClick: _cache[47] || (_cache[47] = ($event: any) => (handleAddCol(dataForm.business.logisticsProviderInfo)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("新增 ")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(MultipleItem, {
              view: props.type === 'view',
              line: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForm.business.logisticsProviderInfo, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '当前物流商',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['business', 'logisticsProviderInfo', index, 'currentLogisticsProvider'],
                      rules: [{ required: isPerfect.value, validator: (rule, value) => checkValidate(rule, value, dataForm.business.logisticsProviderInfo, 'percent', '请选择') }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ParamCodeCascader, {
                          value: item.currentLogisticsProvider,
                          "onUpdate:value": ($event: any) => ((item.currentLogisticsProvider) = $event),
                          options: paramCodeData.lbu_logistics_service_provider,
                          disabled: !props.isEdit,
                          view: props.type === 'view',
                          allowClear: "",
                          onChange: ($event: any) => (onLogisticsProviderSelect(item, index))
                        }, null, 8, ["value", "onUpdate:value", "options", "disabled", "view", "onChange"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '物流商占比(%)',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['business', 'logisticsProviderInfo', index, 'percent'],
                      rules: [{ required: isPerfect.value, validator: (rule, inputValue) => logisticsProviderInfoValidate(rule,inputValue,item)}]
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_28, [
                          _createVNode(_component_CosInputNumber, {
                            value: item.percent,
                            "onUpdate:value": ($event: any) => ((item.percent) = $event),
                            min: 0,
                            disabled: !props.isEdit,
                            onChange: onLogisticsProviderInput,
                            view: props.type === 'view',
                            style: {"width":"100%"}
                          }, null, 8, ["value", "onUpdate:value", "disabled", "view"]),
                          (props.isEdit && dataForm.business.logisticsProviderInfo && dataForm.business.logisticsProviderInfo.length > 1)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                danger: "",
                                style: {"padding":"0 0 0 12px"},
                                onClick: ($event: any) => (handleDelCol(dataForm.business.logisticsProviderInfo, index))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除 ")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_a_col, { span: 12 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, {
          title: "货物品类",
          span: 6
        }, _createSlots({
          default: _withCtx(() => [
            _createVNode(MultipleItem, {
              view: props.type === 'view',
              line: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForm.business.goodsCategoryInfo, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '货物品类',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['business', 'goodsCategoryInfo', index, 'goodsCategory'],
                      rules: [{ required: isPerfect.value, validator: (rule, value) => checkValidate(rule, value, dataForm.business.goodsCategoryInfo, 'percent', '请选择') }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          value: item.goodsCategory,
                          "onUpdate:value": ($event: any) => ((item.goodsCategory) = $event),
                          options: paramCodeData.lbu_sales_category,
                          disabled: !props.isEdit,
                          view: props.type === 'view',
                          allowClear: "",
                          onChange: ($event: any) => (onGoodsCategorySelect(item,index))
                        }, null, 8, ["value", "onUpdate:value", "options", "disabled", "view", "onChange"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '品类占比(%)',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['business', 'goodsCategoryInfo', index, 'percent'],
                      rules: [{ required: isPerfect.value, validator: (rule, inputValue) => goodsCategoryInfoValidate(rule,inputValue,item) }]
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_CosInputNumber, {
                            value: item.percent,
                            "onUpdate:value": ($event: any) => ((item.percent) = $event),
                            min: 0,
                            onChange: onGoodsCategoryInput,
                            disabled: !props.isEdit,
                            view: props.type === 'view',
                            style: {"width":"100%"}
                          }, null, 8, ["value", "onUpdate:value", "disabled", "view"]),
                          (props.isEdit && dataForm.business.goodsCategoryInfo && dataForm.business.goodsCategoryInfo.length > 1)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                danger: "",
                                style: {"padding":"0 0 0 12px"},
                                onClick: ($event: any) => (handleDelCol(dataForm.business.goodsCategoryInfo, index))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除 ")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_a_col, { span: 12 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 2
        }, [
          (props.isEdit)
            ? {
                name: "subTitle",
                fn: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    ghost: "",
                    onClick: _cache[48] || (_cache[48] = ($event: any) => (handleAddCol(dataForm.business.goodsCategoryInfo)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1024),
        _createVNode(_component_dc_layout_card, {
          title: "ERP系统",
          span: 6
        }, _createSlots({
          default: _withCtx(() => [
            _createVNode(MultipleItem, {
              view: props.type === 'view',
              line: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForm.business.erpInfo, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : 'ERP系统',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['business', 'erpInfo', index, 'erpId'],
                      rules: [
            { validator: (rule, value) => checkValidate(rule, value, dataForm.business.erpInfo, 'erpAccount', '请选择') }
          ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          value: item.erpId,
                          "onUpdate:value": ($event: any) => ((item.erpId) = $event),
                          options: paramCodeData.lbu_erp_info,
                          disabled: !props.isEdit,
                          view: props.type === 'view',
                          allowClear: ""
                        }, null, 8, ["value", "onUpdate:value", "options", "disabled", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '关联账号',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['business', 'erpInfo', index, 'erpAccount'],
                      rules: [
            { validator: (rule, value) => checkValidate(rule, value, dataForm.business.erpInfo, 'erpId', '请输入') }
          ]
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(CosInput, {
                            value: item.erpAccount,
                            "onUpdate:value": ($event: any) => ((item.erpAccount) = $event),
                            maxlength: 100,
                            disabled: !props.isEdit,
                            view: props.type === 'view',
                            style: {"width":"100%"}
                          }, null, 8, ["value", "onUpdate:value", "disabled", "view"]),
                          (props.isEdit && dataForm.business.erpInfo && dataForm.business.erpInfo.length > 1)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                danger: "",
                                style: {"padding":"0 0 0 12px"},
                                onClick: ($event: any) => (handleErpInfoDel(index))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除 ")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_a_col, { span: 12 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 2
        }, [
          (props.isEdit)
            ? {
                name: "subTitle",
                fn: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    ghost: "",
                    onClick: _cache[49] || (_cache[49] = ($event: any) => (handleErpInfoAdd()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                key: "0"
              }
            : undefined
        ]), 1024),
        _createVNode(_component_dc_layout_card, {
          title: "其他信息",
          span: 6
        }, {
          default: _withCtx(() => [
            (dataForm.clueStatus === 5)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  label: "无效原因",
                  name: "invalidId",
                  rules: dataForm.clueStatus === 5 ? formRules.invalid : []
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      value: dataForm.invalidId,
                      "onUpdate:value": _cache[50] || (_cache[50] = ($event: any) => ((dataForm.invalidId) = $event)),
                      options: paramCodeData.lbu_invalid_reason,
                      disabled: !props.isEdit,
                      view: props.type === 'view',
                      allowClear: ""
                    }, null, 8, ["value", "options", "disabled", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              label: "上传附件",
              name: "attachment",
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadFile), {
                  value: dataForm.attachment,
                  "onUpdate:value": _cache[51] || (_cache[51] = ($event: any) => ((dataForm.attachment) = $event)),
                  disabled: !props.isEdit
                }, null, 8, ["value", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "备注",
              span: 12,
              name: "remark",
              rules: dataForm.clueStatus === 5 ? formRules.remarkValue : []
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: dataForm.remark,
                  "onUpdate:value": _cache[52] || (_cache[52] = ($event: any) => ((dataForm.remark) = $event)),
                  maxlength: 2000,
                  disabled: !props.isEdit,
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["rules"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_cos_footer_button, {
      value: dataForm,
      "onUpdate:value": _cache[53] || (_cache[53] = ($event: any) => ((dataForm) = $event)),
      formRef: formRef.value,
      resetValue: __props.resetValue,
      loading: loading.value,
      disabled: !props.isEdit,
      permissionPage: permissionPage.value,
      onSubmit: handleSubmit
    }, null, 8, ["value", "formRef", "resetValue", "loading", "disabled", "permissionPage"])
  ], 64))
}
}

})